import { useEffect, useRef } from "react";
import styles from "./Example.module.css";

interface Props {
    text: string;
    value: string;
    onClick: (value: string) => void;
}

export const Example = ({ text, value, onClick }: Props) => {
    const buttonRef = useRef<HTMLButtonElement>(null);

    useEffect(() => {
        const button = buttonRef.current;
        if (!button) return;

        // Reset
        button.style.fontSize = "22px";
        button.textContent = text;

        const containerHeight = button.clientHeight - 40; // minus padding
        let fontSize = 22;

        // Shrink font if overflowing
        while (fontSize > 16 && button.scrollHeight > button.clientHeight) {
            fontSize -= 0.5;
            button.style.fontSize = `${fontSize}px`;
        }

        // If still overflowing, truncate manually
        if (button.scrollHeight > button.clientHeight) {
            let truncatedText = text;
            while (button.scrollHeight > button.clientHeight && truncatedText.length > 0) {
                truncatedText = truncatedText.slice(0, -1);
                button.textContent = truncatedText + "...";
            }
        }
    }, [text]);

    return (
        <button ref={buttonRef} className={styles.exampleButton} title={text} onClick={() => onClick(value)}>
            {text}
        </button>
    );
};
